import React, {Component} from 'react';
import {connect} from 'react-redux';
import Modal from '../components/Modal';
import ScheduleForm from './schedule/ScheduleForm';

@connect(
    state => ({
        isSavingSchedule: state.modal.isSavingSchedule,
    })
)
export default class ScheduleModal extends Component {
    getModalTitle() {
        if(this.props.eventType == 'phonecall') {
            return this.props.scheduleId ? "Update Phone Call" : "Create Phone Call";
        }
        return this.props.scheduleId ? "Update Schedule" : "Create Schedule";
    }
    saveSchedule() {
        this.refs.form.getWrappedInstance().saveSchedule();
    }
    render() {
        var actionButton = this.props.isSavingSchedule ?
            (<button className="btn btn-success disabled">Saving...</button>) :
            (<button className="btn btn-success" onClick={this.saveSchedule.bind(this)}>Save</button>);
        return (
            <Modal actionButton={actionButton} className="modal-success" title={this.getModalTitle()}>
                <ScheduleForm {...this.props} ref="form" />
            </Modal>
        );
    }
}




// WEBPACK FOOTER //
// ./app/components/ScheduleModal.js